export const SectionMixin = {
    methods: {
        enterComponent() { },
        leaveComponent() { },
        onGLFrame() { }
    }
};
